import { lazy, Suspense, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import SubText from "components/shared/SubText";
import MusicService from "services/music/MusicService";
import { Link } from "react-router-dom";
import MusicSkeleton from "../../components/skeleton/MusicSkeleton";
import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";
import SectionHeading from "components/shared/SectionHeading";

const MusicCard = lazy(() => import("pages/musicPage/shared/MusicCard"));

function MusicCarousel({ user }: any) {
  const [randomSongs, setRandomSongs] = useState([]);
  const [isLoading, setIsLoading] = useState<any>(false);

  useEffect(() => {
    setIsLoading(true);
    MusicService.getRandomSongs()
      .then((res: any) => {
        setIsLoading(false);
        setRandomSongs(res.randomSongs);
      })
      .catch((e) => {
        setIsLoading(false);
        // console.log(e);
      });
  }, []);

  return (
    <>
      {!isLoading && (
        <>
          <ErrorBoundary>
            <Suspense fallback={<MusicSkeleton />}>
              <div>
                {" "}
                <div className="flex w-[95%] items-center justify-between">
                  <SectionHeading text="Discover Music" className="font-bold" />
                  <Link to="/music" className="group shrink-0">
                    <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                      See all
                      <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                        →
                      </span>
                    </p>
                  </Link>
                </div>
                <Swiper
                  slidesPerView={6}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    370: {
                      slidesPerView: 2,
                    },
                    700: {
                      slidesPerView: 3,
                    },
                    1000: {
                      slidesPerView: 4,
                    },
                    1200: {
                      slidesPerView: 5,
                    },
                    1400: {
                      slidesPerView: 6,
                    },
                    1600: {
                      slidesPerView: 7,
                    },
                  }}
                  modules={[Pagination, Navigation]}
                  navigation={true}
                  className="mt-8 mb-10 mySwiper"
                >
                  {randomSongs?.map((song, i) => (
                    <SwiperSlide key={i}>
                      <div className="px-1.5 max-sm:px-1">
                        <MusicCard song={song} isLoading={isLoading} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Suspense>
          </ErrorBoundary>
        </>
      )}
      {isLoading && <MusicSkeleton />}
    </>
  );
}

export default MusicCarousel;